var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"masonry-item_type_video"},[_c('div',{staticClass:"masonry-content"},[_c('video',{attrs:{"controls":"","width":"100%","height":"300","src":_vm.item.content.originalUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }